/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import { isCountryFranceOrDomTom } from 'lib/countryHelpers';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IntlMessageComponent from 'components/formatters/intlMessage';

import CompanyBankAccountAddDocumentViewComponent from './view';

import Document from 'models/documents/v2/document';
import DocumentType from 'models/documents/documentType'

import DocumentService from 'services/DocumentService';
import { handleApiFormResponse } from 'lib/forms';
import { DOC_CODE_RIB, DOC_TYPE_RIB, DOC_CODE_BKA, DOC_TYPE_BKA } from 'constants/constants';

type CompanyBankAccountAddDocumentComponentProps = {
  activeCompanyId: number;
  bankAccountId: number;
  bankCountryId: number;
  onClose: () => void;
  onSuccess: () => void;
}

type CompanyBankAccountAddDocumentComponentState = {
  formErrors: string[];
  isProcessing: boolean;
  documentType: DocumentType;
  document: Document;
}

class CompanyBankAccountAddDocumentComponent extends React.Component<CompanyBankAccountAddDocumentComponentProps, CompanyBankAccountAddDocumentComponentState> {

  constructor(props) {
    super(props);
    this.state = {
      form: null,
      formErrors: [],
      isProcessing: false,
      step: 1
    };
  }
  componentDidMount() {
    const document = new Document();
    let documentType = new DocumentType();

    if (isCountryFranceOrDomTom(this.props.bankCountryId)) {
      documentType = new DocumentType(DOC_TYPE_RIB, DOC_CODE_RIB);
    } else {
      documentType = new DocumentType(DOC_TYPE_BKA, DOC_CODE_BKA);
    }
    document.typeId = documentType.typeId;
    document.code = documentType.code;
    document.isRequired = true;
    this.setState({ document, documentType });
  }

  onSuccess = async (document: Document) => {
    try {
      this.setState({ isProcessing: true });
      await this.submitDocument(document, this.props.bankAccountId);
      this.props.onSuccess();
    } catch (e) {
      handleApiFormResponse.call(this, e);
    }
  }

  handleDocumentSelect = (file: File) => {
    const document = this.state.document;
    document.file = file;
    document.filename = file.name;
    document.isInvalid = false;
    document.isMissing = false;
    this.setState({ document });
  };

  handleDocumentSelectFailure = (file: File) => {
    const document = this.state.document;
    document.file = null;
    document.filename = file.name;
    document.isInvalid = true;
    document.isMissing = false;
    this.setState({ document });
  }

  handleDocumentRemove = () => {
    const document = this.state.document;
    document.file = null;
    document.filename = '';
    document.isInvalid = false;
    document.isMissing = false;
    this.setState({ document });
  };

  onSubmit = async () => {
    const document = this.state.document;
    if (document.file === null || document.isMissing || document.isInvalid) {
      document.isMissing = true;
      this.setState({ document });
    } else {
      this.onSuccess(document);
    }
  };

  submitDocument = async (document: Document, bankAccountId: number) => {
    await DocumentService.sendCompanyBankAccountDocument(this.props.activeCompanyId, bankAccountId, document.typeId, document.file);
  }

  render() {
    return (
      <Dialog open onClose={this.props.onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <IntlMessageComponent id="component.company.bankAccounts.adddocument.title" />
        </DialogTitle>

        {this.state.isProcessing &&
          <DialogContent>
            <Box align="center" p={5}>
              <CircularProgress size={60} />
            </Box>
          </DialogContent>
        }

        {!this.state.isProcessing &&
          <CompanyBankAccountAddDocumentViewComponent
            formErrors={this.state.formErrors}
            onClose={this.props.onClose}
            documentType={this.state.documentType}
            document={this.state.document}
            handleDocumentSelect={this.handleDocumentSelect}
            handleDocumentSelectFailure={this.handleDocumentSelectFailure}
            handleDocumentRemove={this.handleDocumentRemove}
            onSubmit={this.onSubmit}
          />
        }
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id
});

export default connect(mapStateToProps)(CompanyBankAccountAddDocumentComponent);
